export const defaultLang: string = "fr";

export const supportedLang: {[key:string]: string} = {
    en: "English",
    fr: "Français",
};

export const langUrl: string = "/i18n/{lang}.json";
